<template>
  <common-page
    ref="commonPage"
    :bg-path="bgPath"
    :web-path="webPath"
    :columns="columns"
    :table-options="tableOptions"
    :search-items="searchItems"
    :form-items="formItems"
  />
</template>
<script>
export default {
  data() {
    return {
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'pharmacy/storage/storage/storagestatement',
      // Web路径
      webPath: 'pharmacy/storage/storage/storagestatement',
      tableOptions: ['details', 'filter'],
      // ===== ===== ===== ===== 页面配置 ===== ===== ===== =====
      // 搜索内容
      searchItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "name",
              name: "名称",
              type: "text",
              span: 6,
              config: {
                edit: false
              }
            },
            {
              code: "typeSign",
              name: "类型标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "1", value: "茶饮" },
                  { key: "2", value: "零食" }
                ]
              }
            }
          ]
        }
      ],
      // 列表内容
      columns: [
        {
          code: "businessTime",
          name: "业务时间",
          span: 6,
          type: "datetime",
          search: true,
          config: {
            edit: false,
            width: 200
          }
        },
        {
          code: "operationTime",
          name: "操作时间",
          span: 6,
          type: "datetime",
          search: true,
          config: {
            edit: false,
            width: 200
          }
        }, {
          code: "statementTypeSign",
          name: "流水状态标识",
          span: 6,
          type: "select",
          search: true,
          config: {
            edit: false,
            defaultValue: '0',
            options: [
              { key: "0", value: "出库" },
              { key: "1", value: "入库" }
            ]
          }
        }, {
          code: "businessTypeSign",
          name: "业务类型标识",
          span: 6,
          type: "select",
          search: true,
          config: {
            edit: false,
            defaultValue: 'receipt_In',
            options: [
              { key: "receipt_In", value: "采购入库" },
              { key: "check_In", value: "盘盈入库" },
              { key: "allocation_In", value: "调拨入库" },
              { key: "return_In", value: "退货入库" },
              { key: "retail_Out", value: "零售出库" },
              { key: "dispense_Out", value: "发药出库" },
              { key: "check_Out", value: "盘亏出库" },
              { key: "other_Out", value: "调拨出库" },
              { key: "return_Out", value: "退货出库" }
            ]
          }
        },
        {
          code: "storageCode",
          span: 6,
          name: "库存单号",
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "pharmacyCode",
          span: 6,
          name: "药房编码",
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "pharmacyName",
          name: "药房名称",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "materielCode",
          name: "药品编码",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "materielName",
          name: "药品名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "qualitySign",
          name: "品质标识",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "1", value: "普通" },
              { key: "2", value: "精品" }
            ]
          }
        },
        {
          code: "number",
          name: "数量",
          span: 6,
          type: "number",
          search: true,
          config: {
            edit: false,
            width: 200
          }
        },
        {
          code: "costPrice",
          name: "单价",
          span: 6,
          type: "number",
          search: true,
          config: {
            edit: false,
            width: 200
          }
        },
        {
          code: "costAmount",
          name: "金额",
          span: 6,
          type: "number",
          search: true,
          config: {
            edit: false,
            width: 200
          }
        },
        {
          code: "sourceOrdCode",
          name: "依据单号",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "sourceItemCode",
          name: "来源单项",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        }
      ],
      // 增加/修改/详情 表单
      formItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "businessTime",
              name: "业务时间",
              span: 6,
              type: "datetime",
              search: true,
              config: {
                edit: false,
                width: 200
              }
            },
            {
              code: "operationTime",
              name: "操作时间",
              span: 6,
              type: "datetime",
              search: true,
              config: {
                edit: false,
                width: 200
              }
            }, {
              code: "statementTypeSign",
              name: "流水状态标识",
              span: 6,
              type: "select",
              search: true,
              config: {
                edit: false,
                defaultValue: '0',
                options: [
                  { key: "0", value: "出库" },
                  { key: "1", value: "入库" }
                ]
              }
            }, {
              code: "businessTypeSign",
              name: "业务类型标识",
              span: 6,
              type: "select",
              search: true,
              config: {
                edit: false,
                defaultValue: 'receipt_In',
                options: [
                  { key: "receipt_In", value: "采购入库" },
                  { key: "check_In", value: "盘盈入库" },
                  { key: "allocation_In", value: "调拨入库" },
                  { key: "return_In", value: "退货入库" },
                  { key: "retail_Out", value: "零售出库" },
                  { key: "dispense_Out", value: "发药出库" },
                  { key: "check_Out", value: "盘亏出库" },
                  { key: "other_Out", value: "调拨出库" },
                  { key: "return_Out", value: "退货出库" }
                ]
              }
            },
            {
              code: "storageCode",
              span: 6,
              name: "库存单号",
              type: "popup",
              config: {
                url: "pharmacy/storage/storage/storage",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false,
                require: true
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("storageName", row.name)
                  this.$refs.commonPage.updateFormData("storageId", row.id)
                }
              }
            },
            {
              code: "pharmacyCode",
              span: 6,
              name: "药房编码",
              type: "popup",
              config: {
                url: "base/user/user/pharmacy",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false,
                require: true
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("pharmacyName", row.name)
                  this.$refs.commonPage.updateFormData("pharmacyId", row.id)
                }
              }
            },
            {
              code: "pharmacyName",
              name: "药房名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "materielCode",
              name: "药品编码",
              type: "popup",
              span: 6,
              config: {
                url: "base/dictionary/medicinedic/materiel",
                filedList: [
                  { code: 'id', name: 'Id' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: { name: '服务' },
                disabled: false
              },
              handleEvent: {
                /**
                 * 开窗组件被选择
                 * @param code
                 * @param row
                 */
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("materielName", row.name)
                  this.$refs.commonPage.updateFormData("materielId", row.id)
                }
              }
            },
            {
              code: "materielName",
              name: "药品名称",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "qualitySign",
              name: "品质标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "1", value: "普通" },
                  { key: "2", value: "精品" }
                ]
              }
            },
            {
              code: "number",
              name: "数量",
              span: 6,
              type: "number",
              search: true,
              config: {
                edit: false,
                width: 200
              }
            },
            {
              code: "costPrice",
              name: "单价",
              span: 6,
              type: "number",
              search: true,
              config: {
                edit: false,
                width: 200
              }
            },
            {
              code: "costAmount",
              name: "金额",
              span: 6,
              type: "number",
              search: true,
              config: {
                edit: false,
                width: 200
              }
            },
            {
              code: "sourceOrdCode",
              name: "依据单号",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "sourceItemCode",
              name: "来源单项",
              span: 6,
              type: "text",
              config: {
                edit: false
              }
            }
          ]
        }
      ]
    }
  }
}
</script>
